define('PartLookup.Assemblies.Detail.View', [
  'SCView',
  'partlookup_diagrams_cell.tpl'
], function (
  SCViewModule,
  partlookup_diagrams_cell_tpl
) {
  'use strict';

  var SCView = SCViewModule.SCView;

  function PartLookupAssembliesDetailView (options) {
    SCView.call(this, options);
    this.model = options.model;
    this.template = partlookup_diagrams_cell_tpl;

  }

  PartLookupAssembliesDetailView.prototype = Object.create(SCView.prototype);

  _.extend(PartLookupAssembliesDetailView.prototype, {

    constructor: PartLookupAssembliesDetailView,

    getContext: function() {
      return {
        id: this.model.get('Id'),
        imageUrl: this.model.get('ImageUrl'),
        isParent: this.model.get('IsParent'),
        name: this.model.get('Name'),
        parentId: this.model.get('ParentId'),
        parentName: this.model.get('ParentName')
      };
    }

  });

  return PartLookupAssembliesDetailView
});
